const section = document.querySelector('.global-section-testimony');
const slider  = section?.querySelector('.global-section-testimony__slider');

if (slider) {
    const cards   = [...slider.querySelectorAll('.avis-card')];
    const prevBtn = section.querySelector('.global-section-testimony__prev');
    const nextBtn = section.querySelector('.global-section-testimony__next');
    const total   = cards.length;

    if (total > 1) {
        slider.style.scrollSnapType = 'none';

        let scrollPos     = 0;
        let pendingIndex  = null;
        let paused        = false;
        let resumeTimer   = null;
        const speed       = 0.6;
        const resumeDelay = 2500;
        const canHover    = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        function getMaxScroll() {
            return Math.max(0, slider.scrollWidth - slider.clientWidth);
        }

        function getTargetForIndex(index) {
            if (index <= 0) return 0;
            // Dernière carte : toujours le vrai max scroll (évite de bloquer à l'avant-dernier)
            if (index >= total - 1) return getMaxScroll();

            return Math.max(0, cards[index].offsetLeft - cards[0].offsetLeft);
        }

        function getCurrentIndex() {
            if (pendingIndex !== null) return pendingIndex;

            const current = slider.scrollLeft;
            const max = getMaxScroll();

            if (current >= max - 2) return total - 1;

            let best = 0;
            let bestDist = Infinity;

            for (let i = 0; i < total; i++) {
                const dist = Math.abs(current - getTargetForIndex(i));
                if (dist < bestDist) {
                    bestDist = dist;
                    best = i;
                }
            }

            return best;
        }

        function pause() {
            paused = true;
            clearTimeout(resumeTimer);
        }

        function scheduleResume() {
            clearTimeout(resumeTimer);
            resumeTimer = setTimeout(() => {
                pendingIndex = null;
                scrollPos = slider.scrollLeft;
                paused = false;
            }, resumeDelay);
        }

        function scrollToIndex(index) {
            pause();

            let nextIndex = index;
            if (nextIndex >= total) nextIndex = 0;
            if (nextIndex < 0) nextIndex = total - 1;

            const next = getTargetForIndex(nextIndex);

            pendingIndex = nextIndex;
            scrollPos = next;

            const behavior = canHover ? 'smooth' : 'auto';
            slider.scrollTo({ left: next, behavior });

            if (!canHover) {
                // Force la position sur iOS (scrollTo peut être clampé / ignoré)
                slider.scrollLeft = next;
                scrollPos = slider.scrollLeft;
            }

            scheduleResume();
        }

        function scrollByStep(direction) {
            scrollToIndex(getCurrentIndex() + direction);
        }

        function animate() {
            if (!paused) {
                scrollPos += speed;

                const maxScroll = getMaxScroll();
                if (maxScroll > 0 && scrollPos >= maxScroll) {
                    scrollPos = 0;
                }

                slider.scrollLeft = scrollPos;
            }

            requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);

        if (canHover) {
            slider.addEventListener('mouseenter', pause);
            slider.addEventListener('mouseleave', scheduleResume);
            prevBtn?.addEventListener('mouseenter', pause);
            nextBtn?.addEventListener('mouseenter', pause);
            prevBtn?.addEventListener('mouseleave', scheduleResume);
            nextBtn?.addEventListener('mouseleave', scheduleResume);
        }

        slider.addEventListener('touchstart', pause, { passive: true });
        slider.addEventListener('touchend', scheduleResume, { passive: true });

        function bindNav(btn, direction) {
            if (!btn) return;

            btn.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && event.button !== 0) return;
                event.preventDefault();
                scrollByStep(direction);
            });

            btn.addEventListener('click', (event) => {
                event.preventDefault();
            });
        }

        bindNav(prevBtn, -1);
        bindNav(nextBtn, 1);
    }

    slider.querySelectorAll('.avis-card__text').forEach(textEl => {
        function updateMask() {
            const atStart = textEl.scrollTop <= 1;
            const atEnd   = textEl.scrollTop >= textEl.scrollHeight - textEl.clientHeight - 1;
            textEl.classList.toggle('is-start', atStart);
            textEl.classList.toggle('is-end', atEnd);
        }

        textEl.addEventListener('scroll', updateMask, { passive: true });
        updateMask();
    });
}
